import Keycloak from 'keycloak-js';

// Initialize Keycloak instance with your Keycloak server and client settings
const keycloak = new Keycloak({
  url: 'https://auth.readyone.training', // Replace with your Keycloak server URL
  realm: 'master',                       // Replace with your realm
  clientId: 'readyone-training-aacp'      // Replace with your clientId
});

export default keycloak;